export const siteInfo = {
  name: '新新漫画',
  tagline: '韩漫日漫国漫大全',
  description: '新新漫画是一个专注于漫画分类与推荐的导航平台，涵盖韩漫、日漫、国漫等多种类型的漫画资源。通过精细的分类系统和热门推荐，帮助漫画爱好者快速找到感兴趣的作品。',
  founded: '2023年',
  mission: '让每一位漫画爱好者都能在这里找到属于自己的那份热爱',
  values: [
    { title: '全面覆盖', description: '韩漫、日漫、国漫应有尽有，类型丰富，应有尽有' },
    { title: '精准推荐', description: '基于热门度和评分，为用户推荐最值得阅读的漫画' },
    { title: '便捷导航', description: '清晰的分类体系和直观的界面设计，找漫画从未如此简单' },
    { title: '持续更新', description: '紧跟漫画市场潮流，持续收录最新热门作品' },
  ],
  stats: [
    { value: '2000+', label: '收录漫画' },
    { value: '10', label: '类型分类' },
    { value: '50万+', label: '月访问用户' },
    { value: '4.9', label: '用户评分' },
  ],
  contact: {
    email: 'contact@xinxinmanhua.com',
    address: '中国上海市浦东新区张江高科技园区',
    wechat: 'xinxinmanhua',
  },
};